/** 解析 symbol 的 base / quote（去掉 _cfd 后按 base_quote 分段） */
export function parseSymbolBaseQuote(symbol) {
  const core = String(symbol || "")
    .toLowerCase()
    .replace(/_cfd$/i, "");
  const parts = core.split("_").filter(Boolean);
  if (parts.length < 2) return { base: "", quote: "" };
  return { base: parts[0], quote: parts[1] };
}

function normalizeCfdSymbol(symbol) {
  const core = String(symbol || "")
    .toLowerCase()
    .replace(/_cfd$/i, "");
  return core ? `${core}_cfd` : "";
}

function symbolContainsLegs(symbol, legA, legB) {
  const { base, quote } = parseSymbolBaseQuote(symbol);
  if (!base || !quote) return false;
  const a = String(legA || "").toLowerCase();
  const b = String(legB || "").toLowerCase();
  return (base === a && quote === b) || (base === b && quote === a);
}

/** 在 symbol 列表中选取首个存在的 symbol（兼容带/不带 _cfd，优先 _cfd） */
function pickExistingSymbol(candidates, symbolSet) {
  for (const candidate of candidates) {
    const base = String(candidate || "").toLowerCase().replace(/_cfd$/i, "");
    if (!base) continue;
    const withCfd = `${base}_cfd`;
    if (symbolSet.has(withCfd)) return withCfd;
    if (symbolSet.has(base)) return withCfd;
  }
  return "";
}

/** 是否展示 K 线：以能否解析到交易对 symbol 为准 */
export function isConvertKlineAvailable(klineSymbol) {
  return !!klineSymbol;
}

/**
 * K 线 symbol：在交易对列表中匹配 From/To，按 market 标准 base_quote 拼法，后缀 _cfd。
 * 找不到交易对则返回 ""，页面不展示 K 线。
 */
export function resolveConvertKlineSymbol(fromCurrency, toCurrency, convertMode, symbols = []) {
  const from = (fromCurrency || "").toUpperCase();
  const to = (toCurrency || "").toUpperCase();
  if (!from || !to || from === to || convertMode === "invalid") return "";

  const legA = from.toLowerCase();
  const legB = to.toLowerCase();

  for (const sym of symbols) {
    if (symbolContainsLegs(sym, legA, legB)) {
      return normalizeCfdSymbol(sym);
    }
  }

  const symbolSet = new Set(
    (symbols || []).flatMap((s) => {
      const lower = String(s).toLowerCase();
      const base = lower.replace(/_cfd$/i, "");
      return base ? [lower, base, `${base}_cfd`] : [lower];
    })
  );

  return pickExistingSymbol([`${legA}_${legB}`, `${legB}_${legA}`], symbolSet);
}
